
import gql from 'graphql-tag';
import ErrorHandler from '@/services/ErrorHandler';
import StorageService from '@/services/StorageService';
import { apolloClient } from '@/apollo';

const UserInfoStore = {
  namespaced: true,
  state: {
    languageId: 1,
    cityId: 0,
    displayName: '',
    balance: 0,
    balanceThreshold: 10,
    languages: [{
      name: 'Lietuvių',
      id: 1,
      locale: 'lt',
    }, {
      name: 'English',
      id: 2,
      locale: 'en',
    }],
    cities: [{
      name: 'Kaunas',
      id: 1,
    }, {
      name: 'Vilnius',
      id: 2,
    }],
  },
  actions: {
    loadUserData({ commit }, {
      languageId, cityId, displayName, balance, balanceThreshold,
    }) {
      commit('updateUserData', {
        languageId, cityId, displayName, balance, balanceThreshold,
      });
    },
    async refetchUserBalance({ state }) {
      try {
        const result = await apolloClient.query({
          fetchPolicy: 'network-only',
          query: gql`query CurrentUserBalance {
            currentUser {
              balance
            }
          }`,
        });

        state.balance = result.data.currentUser.balance;
      } catch (error) {
        ErrorHandler.handleApolloError(error);
      }
    },

    // eslint-disable-next-line no-unused-vars
    async updateUserData({ commit }, {
      languageId, cityId, displayName, refetchDayDishesQuery, balanceThreshold,
    }) {
      try {
        await apolloClient.mutate({
          mutation: gql`mutation SaveUserSettingsMutation($data: UserSettings!) {
            saveUserSettings(data: $data)
          }`,
          variables: {
            data: {
              languageId,
              cityId,
              displayName,
              balanceThreshold,
            },
          },
        });
        StorageService.add('locale.id', languageId);
        StorageService.add('city.id', cityId);

        await apolloClient.queryManager.refetchQueryByName('CurrentUserQuery');
        await apolloClient.queryManager.refetchQueryByName('DaysQuery');

        if (refetchDayDishesQuery) {
          await apolloClient.queryManager.refetchQueryByName('DayDishesQuery');
        }
      } catch (error) {
        ErrorHandler.handleApolloError(error);
      }
    },
  },
  mutations: {
    updateUserData(state, {
      languageId, cityId, displayName, balance, balanceThreshold,
    }) {
      StorageService.add('locale.id', languageId);
      StorageService.add('city.id', cityId);
      state.languageId = languageId;
      state.cityId = cityId;
      state.displayName = displayName;
      state.balance = balance;
      state.balanceThreshold = balanceThreshold;
    },
  },
  getters: {
    userData(state) {
      return {
        languageId: state.languageId,
        cityId: state.cityId,
        displayName: state.displayName,
        balance: state.balance,
        balanceThreshold: state.balanceThreshold,
      };
    },
    languages(state) {
      return state.languages;
    },
    cities(state) {
      return state.cities;
    },
    locale(state) {
      return state.languages.find(l => l.id === state.languageId).locale;
    },
  },
};

export default UserInfoStore;
